import {apiUrl} from '../utils/constants';
import {DELETE, GET, POST, PUT} from './api.service.wrapper';


export const GetReportTypes = async (keyword = '', page = '', perPage = '', is_paginate = true, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }

    if (keyword) {
        params['search'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }

    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.reportTypes, params);
    return response;
}

export const GetReportTypeById = async (id) => {
    let response = '';
    response = await GET(apiUrl.reportTypes + '/' + id);
    return response;
}

export const AddReportType = async (data) => {
    const response = await POST(apiUrl.reportTypes, data);
    return response;
}

export const UpdateReportType = async (id, data) => {
    const response = await PUT(apiUrl.reportTypes, id, data);
    return response;
}

export const DeleteReportType = async (id) => {
    const response = await DELETE(apiUrl.reportTypes, id);
    return response;
}
